import { stringify } from '@lib/json';
import { TYPES } from '@model/utils/types';
import { isNull } from 'lodash';
import { Type } from './Type';

export class String extends Type {
    static getDefault() {
        return '';
    }

    static toValue(value: any, verbose = false): string {
        switch (typeof value) {
            case 'boolean':
                return value ? 'true' : 'false';
            case 'string':
                return value;
            case 'function':
                return '[Function]';
            case 'object':
                if (!isNull(value)) {
                    return stringify(value);
                }
                return verbose ? 'null' : '';
            case 'undefined':
                return verbose ? 'undefined' : '';
            case 'number':
                return `${value}`;
            default:
                return '';
        }
    }
}

String[TYPES.TYPE] = 'string';
